var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurprised(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3728 0 0 5.40185 0 12.0649C0 18.7279 5.3728 24.1298 12 24.1298C18.6272 24.1298 24 18.7279 24 12.0649C24 5.40185 18.6272 0 12 0ZM12 23.1244C5.9344 23.1244 1 18.1633 1 12.0649C1 5.96649 5.9344 1.00541 12 1.00541C18.0652 1.00541 23 5.96649 23 12.0649C23 18.1633 18.0652 23.1244 12 23.1244Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19971 12.0648C8.30428 12.0648 9.19971 11.1646 9.19971 10.054C9.19971 8.94348 8.30428 8.04321 7.19971 8.04321C6.09514 8.04321 5.19971 8.94348 5.19971 10.054C5.19971 11.1646 6.09514 12.0648 7.19971 12.0648Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7993 12.0648C17.9039 12.0648 18.7993 11.1646 18.7993 10.054C18.7993 8.94348 17.9039 8.04321 16.7993 8.04321C15.6947 8.04321 14.7993 8.94348 14.7993 10.054C14.7993 11.1646 15.6947 12.0648 16.7993 12.0648Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8469 5.37813C18.3525 4.10971 16.3733 3.57684 14.4501 3.92431C14.1689 3.9786 14.3729 4.83722 14.6041 4.79138C16.2721 4.49056 17.9869 4.95224 19.2813 6.05135C19.4585 6.20699 20.0633 5.56675 19.8469 5.37813Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55044 3.86366C7.62604 3.51659 5.64724 4.04986 4.15364 5.31747C3.93724 5.50609 4.54124 6.14714 4.71844 5.99069C6.01364 4.89199 7.72844 4.4299 9.39564 4.73072C9.62684 4.77657 9.83164 3.91795 9.55044 3.86366Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5104C13.1046 20.5104 14 19.6101 14 18.4996C14 17.389 13.1046 16.4888 12 16.4888C10.8954 16.4888 10 17.389 10 18.4996C10 19.6101 10.8954 20.5104 12 20.5104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprised);
export default __webpack_public_path__ + "static/media/surprised.92edbf0c7855d4133b5102b6e446942b.svg";
export { ForwardRef as ReactComponent };